<div class="modal fade uploadmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
    	<div class="close_icon">
    		<a data-target="uploadmodal" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
    	</div>
      <div class="modal-body">
      	<div class="row mt-1">
      		<div class="col-lg-11 text-center">
      			<p class="pl-5">
      				<span class="underline">Add Path</span>
      			</p>
      		</div>
      	</div>
      	<div class="row justify-content-center mr-1 mt-4 mb-2">
      		<div class="col-lg-5">
      			<a (click)="path($event)"><img src="./assets/image/upload_drive.png" width="190"></a>
           </div>
           <div class="col-lg-1 pt-5">
           	<p class="pt-5 uploadOption">OR</p>
           </div>
           <div class="col-lg-5">
           	   <img src="./assets/image/upload_folder.png" width="190" id="localpath">
              <input type="file" name="upload" class="form control inputlocalpath" hidden>
           </div>
       </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade uploadpath" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
    	<div class="close_icon">
    		<a data-target="uploadpath" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
    	</div>
      <div class="modal-body">
      	<div class="row mt-1 mb-3">
      		<div class="col-lg-11 text-center">
      			<p class="pl-5">
      				<span class="underline">Add Path</span>
      			</p>
      		</div>
      	</div>
      	<div class="row mt-2">
      		<div class="card-body uploadCard mx-3">
            <form (ngSubmit)="f_s3.form.valid && onSubmit_dts3path(f_s3)" #f_s3="ngForm">
             <div class="col-lg-12 text-center pathText">
             	<p>Add path from cloud storage</p>
             </div>
             <div class="col-lg-12 form-group">
             	<input type="text" [ngModel]  name="s3_path" class="form-control pathLink" placeholder="Add s3://path" 
               #s3_path="ngModel" required [ngClass]="{'is-invalid': f_s3.submitted && s3_path.invalid }">
              <div *ngIf="f_s3.submitted && s3_path.invalid" class="invalid-feedback">
                 <div *ngIf="s3_path.errors.required">s3 path is required</div>
               </div>
             </div>
             <div class="col-lg-12 text-center mt-3 form-group">
             	<button type="submit" class="btn btn-primary px-3 pathButton">Add</button>
             </div>
           </form>
           </div>
       </div>
      </div>
    </div>
  </div>
</div>
